import { render } from "./SnehaSparshamVoManage.vue?vue&type=template&id=79aa77c0&scoped=true"
import script from "./SnehaSparshamVoManage.vue?vue&type=script&lang=js"
export * from "./SnehaSparshamVoManage.vue?vue&type=script&lang=js"

import "./SnehaSparshamVoManage.vue?vue&type=style&index=0&id=79aa77c0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79aa77c0"]])

export default __exports__